export default __webpack_public_path__ + "static/media/left-arrow-back-com.15d5fb42.svg";